interface DeviceInfo {
  browserName: string
  browserVersion: string
  deviceType: string
  operatingSystem: string
  userAgent: string
}

export const detectDeviceInfo = (): DeviceInfo => {
  const userAgent = navigator.userAgent

  // Detect browser
  let browserName = 'Unknown'
  let browserVersion = 'Unknown'

  if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
    browserName = 'Chrome'
    const match = userAgent.match(/Chrome\/([0-9.]+)/)
    browserVersion = match ? match[1] : 'Unknown'
  } else if (userAgent.includes('Firefox')) {
    browserName = 'Firefox'
    const match = userAgent.match(/Firefox\/([0-9.]+)/)
    browserVersion = match ? match[1] : 'Unknown'
  } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    browserName = 'Safari'
    const match = userAgent.match(/Safari\/([0-9.]+)/)
    browserVersion = match ? match[1] : 'Unknown'
  } else if (userAgent.includes('Edg')) {
    browserName = 'Edge'
    const match = userAgent.match(/Edg\/([0-9.]+)/)
    browserVersion = match ? match[1] : 'Unknown'
  }

  // Detect device type
  let deviceType = 'desktop'
  if (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
    deviceType = /iPad/i.test(userAgent) ? 'tablet' : 'mobile'
  }

  // Detect operating system
  let operatingSystem = 'Unknown'
  if (userAgent.includes('Windows NT')) {
    operatingSystem = 'Windows'
  } else if (userAgent.includes('Mac OS X')) {
    operatingSystem = 'macOS'
  } else if (userAgent.includes('Linux')) {
    operatingSystem = 'Linux'
  } else if (userAgent.includes('Android')) {
    operatingSystem = 'Android'
  } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
    operatingSystem = 'iOS'
  }

  return {
    browserName,
    browserVersion,
    deviceType,
    operatingSystem,
    userAgent
  }
}